@if (form) {
	<div
		class="trailing-stop-controls"
		[class.disabled]="disabled()"
		[formGroup]="form"
	>
		<div class="trail-box">
			<label
				class="trail-select"
				[tuiDropdown]="trailTypesList"
				[(tuiDropdownOpen)]="isOpenTrailTypes"
				[tuiDropdownEnabled]="!disabled()"
			>
				<p class="trail-title">{{ activeTrailTypeLabel() | translate }}</p>
				<app-image
					class="chevron"
					[class.open]="isOpenTrailTypes()"
					imageSrc="/images/icons/chevron-down.svg"
					imageAlt="chevron"
				/>
			</label>
		</div>

		<div class="trail-input">
			<tui-textfield
				[iconStart]="
					form.get('type')?.value === trailTypeEnum.PRICE
						? '@tui.dollar-sign'
						: form.get('type')?.value === trailTypeEnum.PERCENT
							? '@tui.percent'
							: ''
				"
				tuiTextfieldSize="s"
				[tuiTextfieldCleaner]="true"
			>
				<input
					inputNumberSigns
					tuiInputNumber
					formControlName="value"
					[tuiNumberFormat]="{
						decimalSeparator: ',',
						precision: precision(),
						decimalMode: 'not-zero',
					}"
					[min]="minValue()"
					[step]="minValue()"
				/>
			</tui-textfield>
		</div>
	</div>
}

<ng-template #trailTypesList>
	@let isPercent = form?.get('type')?.value === trailTypeEnum.PERCENT;

	<tui-data-list
		class="trail-types-list"
		size="s"
	>
		<li
			class="trail-types-item"
			[class.selected]="isPercent"
			(click)="setType(trailTypeEnum.PERCENT)"
		>
			{{ 'trailingStop.percent' | translate }}

			@if (isPercent) {
				<tui-icon
					class="icon"
					icon="@tui.check"
				/>
			}
		</li>

		<li
			class="trail-types-item"
			[class.selected]="!isPercent"
			(click)="setType(trailTypeEnum.PRICE)"
		>
			{{ 'trailingStop.price' | translate }}

			@if (!isPercent) {
				<tui-icon
					class="icon"
					icon="@tui.check"
				/>
			}
		</li>
	</tui-data-list>
</ng-template>
